"use client";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { useTheme } from "@emotion/react";
import { Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import Image from "next/image";
import ButtonComponent from "../Button";
import ModalComponent from "../Modal";
import { useDispatch, useSelector } from "react-redux";
import { setModalAttributes } from "@/lib/redux/slice/ModalSlice";

const DataProtectionModal = () => {
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const { open, type } = useSelector((state) => state?.modal);

  const handleButtonClick = () => {
    dispatch(setModalAttributes({ open: false, message: "", type: "" }));
  };
  return (
    <ModalComponent
      maxWidth={isBelowMd ? "xs" : "md"}
      open={open}
      closeButtonRequired={false}
    >
      <Grid
        container
        spacing={3}
        padding={2}
        pb={0}
        // flexDirection={{ md: "row", xs: "column" }}
        alignItems="center"
        justifyContent={"space-between"}
        // gap={1}
      >
        <Grid
          item
          md={6}
          xs={12}
          sx={{
            backgroundColor: { md: "#E9FFE6", xs: "none" },
            height: { md: "436px" },
            width: { md: "463px" },
          }}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Image
            src={IMAGES.dataProtection}
            height={isBelowMd ? "120" : "191px"}
            width={isBelowMd ? "135" : "216px"}
            alt="data protection"
          />
        </Grid>
        <Grid item md={6} xs={12} justifyContent="center" alignItems={"center"}>
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            fontWeight={{ md: 700, xs: 500 }}
            fontSize={{ md: "24px", xs: "16px" }}
            color={WEB_COLORS.darkTeal}
            mb={1}
          >
            Your data is secured with us!
          </Typography>
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            fontWeight={400}
            fontSize={{ md: "14px", xs: "12px" }}
            color={WEB_COLORS.textFadeColor}
            mb={2}
          >
            To give you the best possible solutions, we need to analyze your
            transactions for the last 6 months. We do not store your Net Banking
            ID/Password.
          </Typography>

          <Stack width={"100%"} flexGrow={1}>
            <ButtonComponent onClick={handleButtonClick}>
              OK, I Understand
            </ButtonComponent>
          </Stack>
        </Grid>
      </Grid>
    </ModalComponent>
  );
};

export default DataProtectionModal;
